var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkinline = function SvgLinkinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 19 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#21201F",
    strokeWidth: 1.037,
    d: "M10.797 6.777c-.175-.525-.84-1.575-2.101-1.575-1.26 0-5.428 4.202-7.353 6.303-.35.525-.736 1.89.525 3.151 1.576 1.576 4.2.525 5.776-1.05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#21201F",
    strokeWidth: 1.037,
    d: "M8.458 9.78c.181.523.86 1.565 2.12 1.549s5.375-4.27 7.274-6.394c.344-.53.712-1.9-.564-3.145-1.595-1.556-4.206-.473-5.762 1.123"
  })));
};
export default SvgLinkinline;